import { Component, createEffect, createSignal, Index, Show } from 'solid-js';
import { ContextMenuItemConfig, DataItem, MetaDataConfig } from './interfaces';
import DataGroupSectionItem from './DataGroupSectionItem';
import { Icon } from '@tcweb/connect-ui';

export interface DataGroupSectionProps {
  dataGroupId: string;
  dataGroupName: string;
  dataGroupLength: number;
  icon: string;
  initialExpanded: boolean;
  dataItems: DataItem[];
  metaData: MetaDataConfig;
  contextMenuItems?:
    | ContextMenuItemConfig[]
    | ((file: DataItem) => ContextMenuItemConfig[]);
  onItemVisibilityChange(
    dataType: string,
    dataId: string,
    visible: boolean
  ): void;
  onItemLoadCancel?(dataType: string, dataId: string): void;
  onSectionToggle?(
    sectionId: string,
    sectionName: string,
    expanded: boolean
  ): void;
  disabled?: boolean;
  disabledReason?: string;
}

const DataGroupSectionSansModus: Component<DataGroupSectionProps> = (props) => {
  const [isExpanded, setIsExpanded] = createSignal(props.initialExpanded);

  createEffect(() => {
    setIsExpanded(props.initialExpanded);
  });

  const toggleExpanded = (): boolean => {
    const nextExpanded = !isExpanded();
    setIsExpanded(nextExpanded);
    props.onSectionToggle?.(
      props.dataGroupId,
      props.dataGroupName,
      nextExpanded
    );
    return nextExpanded;
  };

  // /* Disable for Q2 */
  // const allToggled = createMemo(
  //   () => items.length > 0 && items.every((item) => item['visible'])
  // );

  const label = (): string =>
    `${props.dataGroupName} (${props.dataGroupLength.toString()})`;

  return (
    <>
      <modus-wc-tooltip
        content={props.disabledReason}
        disabled={!props.disabled || !props.disabledReason}
        position="bottom"
      >
        <section
          class={`flex justify-start items-center py-3 pl-2 h-9 ${props.disabled ? 'opacity-50' : ''}`}
        >
          <button
            onClick={toggleExpanded}
            disabled={props.disabled}
            data-testid={`data-group-section-expand-${props.dataGroupName.replace(' ', '')}`}
            class={`rounded-sm flex transition-colors duration-200 hover:bg-[#e0e1e9]`}
          >
            <modus-wc-icon
              class="h-6 transition-transform"
              size="md"
              name={isExpanded() ? 'caret_down' : 'caret_right'}
            />
          </button>
          <Icon icon={props.icon} size="icon-small" class="mr-2 ml-1" />
          <span class={props.disabled ? 'text-gray-500' : ''}>{label()}</span>
        </section>
      </modus-wc-tooltip>

      <Show when={!props.disabled && isExpanded()}>
        <Index each={props.dataItems}>
          {(file) => (
            <DataGroupSectionItem
              id={file()[props.metaData.id] as string}
              dataItem={file()}
              metadata={props.metaData}
              visible={file().visible || false}
              loading={file().loading || false}
              deleting={file().deleting || false}
              contextMenuItems={
                typeof props.contextMenuItems === 'function'
                  ? props.contextMenuItems(file())
                  : (props.contextMenuItems ?? [])
              }
              onItemVisibilityChange={props.onItemVisibilityChange}
              onItemLoadCancel={props.onItemLoadCancel}
            />
          )}
        </Index>
      </Show>
    </>
  );
};

export default DataGroupSectionSansModus;
